;(function() {
  'use strict'

  notifyService.$inject = ["$timeout", "$window"];
  angular
    .module('core.services')
    .service('notifyService', notifyService)
    .run(run)

  // --------------------

  /* @ngInject */
  function notifyService($timeout, $window) {
    return {
      init: init,
      show: show,
    }

    function init() {
      if (!window.Notification) {
        return
      }
      if (Notification.permission === 'default') {
        Notification.requestPermission()
      }
    }

    function show(title, options, clickFn) {
      options = options || {}
      if (!window.Notification || Notification.permission !== 'granted') {
        return
      }
      var defaultOptions = {
        icon: 'http://i.imgur.com/xrYBAmS.png',
      }
      options = _.extend(defaultOptions, options)

      var notification = new Notification(title, options)
      if (clickFn) {
        notification.addEventListener('click', function() {
          $window.focus()
          clickFn()
        })
      }

      $timeout(function() {
        notification.close()
      }, 7000)
    }
  }

  /* @ngInject */
  function run() {
    // notifyService.init();
  }
})()
